import { render } from "./SpaceView.vue?vue&type=template&id=a9e53950&scoped=true"
import script from "./SpaceView.vue?vue&type=script&lang=js"
export * from "./SpaceView.vue?vue&type=script&lang=js"

import "./SpaceView.vue?vue&type=style&index=0&id=a9e53950&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e53950"]])

export default __exports__